import { index as getList, listMetrics } from "~/api/site";
import * as types from "../mutation-types";
import store from "../../store";
import { entityStoreStatus } from "~/mixins/entityStoreStatus";
import { clearableStore } from '~/mixins/clearableStore';

export const state = {
  list: null,
  metrics: null,
  isLoading: false,
  isInitialLoadPending: true,
};

export const mutations = {
  ...clearableStore.mutations,
  [types.SET_IS_LOADING_CONTRACT_SITE](state, status) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_SITE](state, contractSite) {
    state.list = contractSite.data;
    state.isInitialLoadPending = false;
  },
  [types.SET_SITES_METRIC](state, data) {
    const incoming = Array.isArray(data?.data) ? data.data : [];

    if (!state.metrics || !Array.isArray(state.metrics)) {
      state.metrics = incoming;
      return;
    }

    const byName = {};

    state.metrics.forEach((m) => {
      if (m && m.name && !(m.name in byName)) {
        byName[m.name] = m;
      }
    });

    incoming.forEach((m) => {
      if (m && m.name) {
        byName[m.name] = m;
      }
    });

    state.metrics = Object.values(byName);
  }
};

export const actions = {
  fetchContractSites({ commit }, contractId = null) {
    commit(types.SET_IS_LOADING_CONTRACT_SITE, true);

    let activeContractId =
      contractId || store.getters["contract/activeContract"]?.id;

    if (activeContractId) {
      getList(activeContractId).then((response) => {
        let { data } = response;
        commit(types.SET_CONTRACT_SITE, data);
        commit(types.SET_IS_LOADING_CONTRACT_SITE, false);
      });
    }
  },

  async fetchSitesMetrics({ commit }, contractId = null) {
    try {
      await listMetrics(contractId).then(({ data }) => {
        commit(types.SET_SITES_METRIC, data);
      });
    } catch (e) {
      // commit(types.FETCH_USER_FAILURE);
    }
  }
};

export const getters = {
  list: (state) => state.list,
  isLoading: (state) => state.isLoading,
  isInitialLoadPending: (state) => state.isInitialLoadPending,
  metrics: (state) => state.metrics,
  getMetric: (state) => (name) => {
    const metric = state.metrics?.find(b => b.name === name);
    return metric;
  },
  ...entityStoreStatus.getters
};
